/**
 * Build https://wa.me/<digits> from a full URL or raw digits (legacy env).
 * Matches Django _whatsapp_href_from_setting behavior for SPA fallbacks.
 */
export function buildWaMeUrl(input) {
  if (input == null || input === '') return ''
  const s = String(input).trim()
  if (!s) return ''
  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s)
      if (u.hostname === 'wa.me' || u.hostname === 'www.wa.me') {
        const path = u.pathname.replace(/^\//, '')
        const digits = path.replace(/\D/g, '')
        return digits ? `https://wa.me/${digits}` : ''
      }
      return s
    } catch {
      return s
    }
  }
  const digits = s.replace(/\D/g, '')
  if (!digits) return ''
  return `https://wa.me/${digits}`
}

/**
 * Env fallbacks for whatsappEntryUrl when GET /auth/public-site-config/ is empty or fails.
 * Order: VUE_APP_WHATSAPP_PUBLIC_BASE_URL → VUE_APP_PUBLIC_WHATSAPP_NUMBER → same default as Django.
 */
export function resolvePublicWhatsappHref() {
  // Prefer VUE_APP_WHATSAPP_PUBLIC_BASE_URL first
  const primaryEnv = typeof process !== 'undefined' && process.env && process.env.VUE_APP_WHATSAPP_PUBLIC_BASE_URL
    ? process.env.VUE_APP_WHATSAPP_PUBLIC_BASE_URL
    : ''
  const fromPrimary = buildWaMeUrl(primaryEnv || '')
  if (fromPrimary) return fromPrimary

  // Then fallback to legacy VUE_APP_PUBLIC_WHATSAPP_NUMBER
  const legacy = typeof process !== 'undefined' && process.env && process.env.VUE_APP_PUBLIC_WHATSAPP_NUMBER
    ? process.env.VUE_APP_PUBLIC_WHATSAPP_NUMBER
    : ''
  const fromLegacy = buildWaMeUrl(legacy || '')
  if (fromLegacy) return fromLegacy

  // If both are not set, return empty string (since .env is required for number)
  return ''
}
